import React, { useState, useRef, useEffect } from "react";
import { Box, Heading, useToast } from "@chakra-ui/react";
import banner from "../../assets/images/carbon-foot-print-banner.jpg";
import Navbar from "../Navbar";
import darkLogo from "../../assets/images/Newlogo-black.png";
import BackToTopButton from "../common/BackToTopButton";
import CreatorsBusinessBanner from "../common/CreatorsBusinessBanner";
import Footer from "../Footer";
import { Helmet } from "react-helmet-async";
import StepsProgress from "./StepsProgress";
import OffsetProgram from "./OffsetProgram";
import OffsetCalculator from "./OffsetCalculator";
import ProofOfImpact from "./ProofOfImpact";
import FAQs from "./FAQs";
import JoinCommunity from "./JoinCommunity";
import Translate from "../LanguageTranslation/Translate";

const CreatorPage = () => {
  const toast = useToast();
  const [activeStep, setActiveStep] = useState(0); // 0,1,2
  const [cause, setCause] = useState("");
  const [paymentData, setPaymentData] = useState(null); // Store payment link and other data

  // Initialize cause from localStorage on component mount
  useEffect(() => {
    const savedCause = localStorage.getItem('selectedCause');
    if (savedCause) {
      setCause(savedCause);
    }
  }, []);

  const translatedTitle = Translate({
    text: "Carbon Footprint",
    as: "string",
  });

  // Function to handle moving to Step 3 with payment data
  const handleMoveToStep3 = (data) => {
    setPaymentData(data);
    setActiveStep(2);
  };

  return (
    <>
      <Helmet>
        <title>{translatedTitle}</title>
        <meta
          name="description"
          content="Build your online travel career with NOMAD360. For outdoor creators ready to grow their brand, connect, and earn online."
        />
        <meta
          name="description:mobile"
          content="Build your online travel career with NOMAD360. For outdoor creators ready to grow, connect, and earn."
        />
      </Helmet>

      <Box position="absolute" top={0} left={0} width="100%" zIndex="2">
        <Navbar
          bgColor="white"
          linkColor="black"
          styling="outline"
          logoSrc={darkLogo}
          userProfileBgColor="transparaent"
          languageCodeColor="black"
        />
        <CreatorsBusinessBanner
          heading={
            <>
              {/* Travel Green,   */}
              <Translate text="Travel Green," />
              <br />
              <Translate text="Explore Responsibly" />
            </>
          }
          banner={banner}
        />
        <StepsProgress
          activeStep={activeStep}
          onStepClick={(stepIndex) => setActiveStep(stepIndex)}
        />
        {activeStep === 0 && (
          <OffsetProgram
            setActiveStep={setActiveStep}
            cause={cause}
            setCause={setCause}
          />
        )}{" "}
        {/* Step 1 UI */}
        {activeStep === 1 && (
          <OffsetCalculator 
            cause={cause} 
            setCause={setCause}
            onMoveToStep3={handleMoveToStep3}
          />
        )}{" "}
        {/* Step 2 UI */}
        {activeStep === 2 && (
          <ProofOfImpact 
            paymentData={paymentData}
            cause={cause}
            onBackToStep2={() => setActiveStep(1)}
          />
        )}
        <FAQs />
        <JoinCommunity />
        <Footer />
        <BackToTopButton />
      </Box>
    </>
  );
};

export default CreatorPage;
